export default {
  common: {
    search: '查 询',
    reset: '重 置',
    deleteTip: '确定删除吗？',
    title: '提示',
    confirm: '确定',
    cancel: '取消'
  },
  select: {
    loading: '加载中',
    noMatch: '无匹配数据',
    noData: '无数据',
    placeholder: '请选择'
  },
  input: {
    placeholder: '请输入'
  },
  tableFilter: {
    expand: '展开',
    packUp: '收起'
  },
  table: {
    toolbar: {
      reset: '重置',
      refreshTable: '刷新列表',
      exportExcel: '导出Excel',
      combinationSort: '组合排序',
      columnsSetup: '列设置',
      leftFixed: '左固定',
      notFixed: '不固定',
      rightFixed: '右固定',
      default: '默认',
      sortUp: '升序',
      sortDown: '降序',
      fixedSort: '固定 / 排序',
      sortDrag: '排序 / 拖动',
      dragDropSort: '拖拽排序',
      confirm: '确定',
      restore: '还原',
      colorPickerMessage: '请至少选择一条数据'
    }
  },
  apexNavigator: {
    title: 'Apex 产品地图己上线',
    content: 'Apex产品地图全新上线!一图掌握全局，探索从此开始！欢迎体验',
    view: '查看',
    cancel: '退出'
  }
}
